import type { MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './AppLinkButton.module.css';

type LinkMode = {
  to: string;
  children: ReactNode;
  className?: string;
};

type ButtonMode = {
  to?: undefined;
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

export type AppLinkButtonProps = LinkMode | ButtonMode;

function isLinkMode(props: AppLinkButtonProps): props is LinkMode {
  return typeof (props as LinkMode).to === 'string';
}

export const AppLinkButton = (props: AppLinkButtonProps) => {
  const { children, className } = props;
  const cls = [styles.root, className].filter(Boolean).join(' ');

  if (isLinkMode(props)) {
    return (
      <Link to={props.to} className={cls}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={cls} onClick={props.onClick} disabled={props.disabled}>
      {children}
    </button>
  );
};
